/**
 * Bulk Registration Validation Schema
 * Requirements: 13.2 - CSV format validation
 */
import { z } from 'zod';

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const usernameRegex = /^[a-zA-Z0-9_-]+$/;
// Cognito password requirements: 8+ chars, uppercase, lowercase, number, special char
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

export const bulkRegistrationUserSchema = z.object({
  email: z
    .string()
    .min(1, 'メールアドレスを入力してください')
    .regex(emailRegex, '有効なメールアドレスを入力してください'),
  username: z
    .string()
    .min(3, 'ユーザー名は3文字以上で入力してください')
    .max(50, 'ユーザー名は50文字以内で入力してください')
    .regex(usernameRegex, 'ユーザー名は英数字、ハイフン、アンダースコアのみ使用できます'),
  name: z
    .string()
    .min(1, '名前を入力してください')
    .max(100, '名前は100文字以内で入力してください'),
  password: z
    .string()
    .min(8, 'パスワードは8文字以上で入力してください')
    .regex(passwordRegex, 'パスワードは大文字、小文字、数字、特殊文字を含む必要があります')
    .optional(),
  role: z.enum(['user', 'admin']).optional().default('user'),
});

export type BulkRegistrationUserInput = z.infer<typeof bulkRegistrationUserSchema>;
